import { PRODUCTS } from "@/lib/site";

const DISCLOSURE = "Affiliate disclosure: I'm an independent ClickBank affiliate and may earn a commission if you buy through my link, at no extra cost to you.";
const HEALTH = "These statements have not been evaluated by the FDA. This product is not intended to diagnose, treat, cure or prevent any disease. Talk to your doctor before use. Results vary.";

export const KIT = {
  "joint-genesis": {
    title: "Joint Genesis Review: Can Mobilee® Help Stiff Joints Move Again?",
    hook: "Move like your joints remember.",
    intro: "Joint Genesis by BioDynamix is a daily, doctor-formulated capsule built around Mobilee® — a hyaluronic-acid matrix aimed at the cushioning “joint jelly” (synovial fluid) between your bones.",
    points: ["Hero ingredient: Mobilee® (hyaluronic acid, polysaccharides, collagen)", "Botanicals: French maritime pine bark, Boswellia serrata, ginger root", "BioPerine® black-pepper extract to help absorption", "30 capsules per bottle — one simple daily ritual"],
    price: "See today's price and guarantee on the official site.",
    image: "/joint-genesis-doctor.webp",
    tags: ["jointhealth", "jointpain", "mobility", "healthyaging", "jointgenesis", "supplements", "activelifestyle"],
  },
  prostavive: {
    title: "ProstaVive Review: One Scoop a Day for Prostate, Flow & Sleep Support",
    hook: "Strong flow. Deep sleep. Feel like you.",
    intro: "ProstaVive is a powdered drink mix — one scoop, one glass a day — with nutrients the maker says support prostate blood flow, healthy urine flow, sleep and energy.",
    points: ["8 botanicals: Boron, Tongkat Ali, Ashwagandha, Fenugreek, Panax Ginseng, Maca Root, Artichoke, Nettle Root", "Mineral blend: Zinc, Magnesium, Vitamin D", "6 bottles $39 each ($234) · 3 bottles $59 each ($177) · 1 bottle $79", "2 free bonus guides with 3 & 6 bottle packs"],
    price: "Prices as listed on the official site — confirm at checkout.",
    image: "/prostavive-jars.webp",
    tags: ["prostatehealth", "menshealth", "prostavive", "healthyaging", "mensupplements", "sleepbetter", "over40"],
  },
  "nitric-boost": {
    title: "Nitric Boost Review: Nitric Oxide Support for Male Performance",
    hook: "Don't just get by. Dominate.",
    intro: "Nitric Boost Ultra is a one-scoop daily powder designed to support sexual performance naturally by helping your body make nitric oxide and protect cGMP for healthy blood flow.",
    points: ["8 ingredients: Beet Root, L-Arginine, L-Citrulline DL-Malate, Niacin, Horny Goat Weed, Ginkgo Biloba, Dong Quai, D-Aspartic Acid", "6 jars $49 each ($294) · 3 jars $59 each ($177) · 1 jar $69", "Free USA shipping + 2 free bonuses on 3 & 6 jar packs", "60-day money-back guarantee (per the maker)"],
    price: "Prices as listed on the official site — confirm at checkout.",
    image: "/nitric-jars.webp",
    tags: ["menshealth", "nitricoxide", "nitricboost", "malevitality", "bloodflow", "mensupplements", "confidence"],
  },
};

export const buildKit = (slug, origin) => {
  const k = KIT[slug];
  const p = PRODUCTS[slug];
  const review = `${origin}${p.path}`;
  const img = `${origin}${k.image}`;
  const hashtags = k.tags.map((t) => `#${t}`).join(" ");
  const bullets = k.points.map((x) => `✔ ${x}`).join("\n");

  const wordpress = `<!-- ${p.name} post — paste into a WordPress "Custom HTML" block -->
<p><em>${DISCLOSURE}</em></p>
<h2>${k.hook}</h2>
<p><img src="${img}" alt="${p.name}" style="max-width:100%;height:auto;border-radius:16px" /></p>
<p>${k.intro}</p>
<h3>What you should know</h3>
<ul>
${k.points.map((x) => `  <li>${x}</li>`).join("\n")}
</ul>
<p>${k.price}</p>
<p style="text-align:center"><a href="${p.hoplink}" target="_blank" rel="sponsored nofollow noopener" style="display:inline-block;padding:14px 28px;background:#D96B43;color:#fff;border-radius:999px;font-weight:700;text-decoration:none">Visit the official ${p.name} site »</a></p>
<p>Read our full review: <a href="${review}" target="_blank" rel="noopener">click here</a></p>
<hr />
<p style="font-size:13px;color:#666">${HEALTH}</p>
<p style="font-size:13px;color:#666">ClickBank is the retailer of products on this site. CLICKBANK® is a registered trademark of Click Sales Inc. and used by permission. ClickBank's role as retailer does not constitute an endorsement of these products.</p>
<p style="font-size:13px;color:#666"><a href="${origin}/privacy">Privacy Policy</a> · <a href="${origin}/terms">Terms &amp; Conditions</a> · <a href="${origin}/disclaimer">Disclaimer</a> · <a href="${origin}/affiliate-disclosure">Affiliate Disclosure</a></p>`;

  const facebook = `${k.hook}

${k.intro}

${bullets}

🛒 Official site: ${p.hoplink}

${DISCLOSURE} ${HEALTH}

${hashtags}`;

  const instagram = `${k.hook}

${k.intro}

${bullets}

🔗 Full review + official link in bio

${DISCLOSURE} Not medical advice — talk to your doctor. Results vary.

${hashtags} #gobbloo`;

  const youtube = `TITLE:
${k.title}

DESCRIPTION:
${k.hook} ${k.intro}

▶ Official ${p.name} site: ${p.hoplink}

In this video:
${bullets}

${k.price}

────────
${DISCLOSURE}
${HEALTH}

TAGS:
${k.tags.join(", ")}, ${p.name.toLowerCase()} review`;

  return { wordpress, facebook, instagram, youtube, title: k.title };
};
